import React, { useCallback, useState } from "react";
import { useStyles } from "../../assets/jss/views/Auth";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomTextField from "../CustomComponents/CustomTextField/CustomTextField";
import CustomLink from "../CustomComponents/CustomLink/CustomLink";
import CustomButton from "../CustomComponents/CustomButton/CustomButton";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import {
    isUserLoggedIn,
    setLocalStorage,
    setGroupList,
    setSession,
    setCurrentGroupPreference,
    getRequestUrl,
    unsetRequestUrl,
    setCompaEnabledForView,
    setDistractionEnabledForView
} from "../../services/LocalStorageService";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { getLoginUser, getSSOLoginUser } from "../../services/LoginUser";
import { useTranslation } from "react-i18next";
import {
    setEventType,
    setEventCategory,
} from "../../services/LocalStorageService";
import { getEventCategories, getEventTypes } from "../../services/GetEventTypes";
import { useParams } from "react-router-dom";
import { Backdrop, CircularProgress } from "@material-ui/core";
import PageLoader from "../PageLoader/PageLoader";
export default function Login(props) {
    const params = useParams();
    const { t } = useTranslation();
    const history = useHistory();
    const classes = useStyles();
    const search = history.location.search;
    const queryParams = new URLSearchParams(search);
    const ssoToken = queryParams.get('ssoToken');
    const email = queryParams.get("email");
    const [statusCode, setStatusCode] = useState(null);

    if (isUserLoggedIn(props)) {
        if (history && history.location && history.location.state && history.location.state.from && history.location.state.from.pathname) {
            history.push(history.location.state.from.pathname);
        } else {
            history.push("/dashboard");
        }
    }

    const [user, setUser] = useState({
        isLoggedIn: false,
        incorrectCredentials: false,
        errorMessage: t("SOMETHING_WENT_WRONG"),
        email: "",
        password: "",
        emailPattern:
            "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$",
    });
    const [loading, setLoading] = useState(false);
    const [requestUrl, setRequestUrl] = useState(getRequestUrl);
    // const[isDistractionEnabledForView, setDistractionEnabledForView]= useState(0);
    // const[isCompaEnabledForView, setCompaEnabledForView]= useState(0);

    function closeZendeskChatOnLoad() {
        const win = (window as any);
        if (win as any && win.zE && win.zE.hide && win.zE.show) {
            win.zE.hide();
            win.zE.show();
        }
    }

    useEffect(() => {
        closeZendeskChatOnLoad();
    });

    async function loginUser() {
        setRequestUrl(getRequestUrl);
        const redirectUrl = getRequestUrl();
        const data = await getLoginUser(user.email.trim(), user.password);
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201)
        ) {
            if (data.status.code === 0) {
                /* setUser({
                    ...data.content.user,
                    isCompaEnabledForView:data.content.isCompaEnabledForView,
                    isDistractionEnabledForView:data.content.isDistractionEnabledForView,
                    isLoggedIn: true,
                    incorrectCredentials: false,
                }); */
                setLocalStorage(data.content.user);
                setGroupList(data.content.groups);
                setSession(data.content.session);
                const currentGroupId = data.content.session.currentGroupId;
                const currentGroup = data.content.groups.find(
                    (group) => group.id === currentGroupId
                );
                setDistractionEnabledForView(data.content.isDistractionEnabledForView);
                setCompaEnabledForView(data.content.isCompaEnabledForView);
                setCurrentGroupPreference(currentGroup.groupPreferences);

                const eventTypeData = await getEventTypes(params);
                if (
                    eventTypeData &&
                    (eventTypeData.status.code === 0 ||
                        eventTypeData.status.code === 200 ||
                        eventTypeData.status.code === 201) &&
                    eventTypeData.content
                ) {
                    setEventType(eventTypeData.content);
                }

                const eventCatData = await getEventCategories(params);
                if (
                    eventCatData &&
                    (eventCatData.status.code === 0 ||
                        eventCatData.status.code === 200 ||
                        eventCatData.status.code === 201) &&
                    eventCatData.content
                ) {
                    setEventCategory(eventCatData.content);
                }

                let url;
                if (redirectUrl && redirectUrl.pathname) {
                    url = redirectUrl.pathname;
                    if (redirectUrl.hash) {
                        url += redirectUrl.hash;
                    }
                }
                if (history && history.location && history.location.state && history.location.state.from && history.location.state.from.pathname) {
                    history.push(history.location.state.from.pathname, {
                        from: history.location.state.from.pathname && history.location.state.from.pathname.includes('/admin') ? '/admin' : '/dashboard'
                    });
                } else {
                    history.push(url && url.length ? url : "/dashboard", {
                        from: url && url.includes('/admin') ? '/admin' : '/dashboard'
                    });
                }

                unsetRequestUrl();
            } else {
                setUser({
                    ...user,
                    incorrectCredentials: true,
                    errorMessage: data.status.message,
                });
                setLoading(false);
            }
        } else {
            setUser({
                ...user,
                incorrectCredentials: true,
                errorMessage: data.status.message,
            });
            setLoading(false);
        }
    }

    useEffect(() => {
        loginSSOUser();
    }, []);

    async function loginSSOUser() {
        try {
            if (ssoToken !== undefined && ssoToken !== null && email !== undefined && email !== null) {
                const data = await getSSOLoginUser(email.trim(), ssoToken.trim());
                if (
                    data &&
                    (data.status.code === 0 ||
                        data.status.code === 200 ||
                        data.status.code === 201)
                ) {
                    if (data.status.code === 0) {
                        setLocalStorage(data.content.user);
                        setGroupList(data.content.groups);
                        setSession(data.content.session);
                        const currentGroupId = data.content.session.currentGroupId;
                        const currentGroup = data.content.groups.find(
                            (group) => group.id === currentGroupId
                        );
                        setDistractionEnabledForView(data.content.isDistractionEnabledForView);
                        setCompaEnabledForView(data.content.isCompaEnabledForView);
                        setCurrentGroupPreference(currentGroup.groupPreferences);

                        const eventTypeData = await getEventTypes(params);
                        if (
                            eventTypeData &&
                            (eventTypeData.status.code === 0 ||
                                eventTypeData.status.code === 200 ||
                                eventTypeData.status.code === 201) &&
                            eventTypeData.content
                        ) {
                            setEventType(eventTypeData.content);
                        }
                        const eventCatData = await getEventCategories(params);
                        if (
                            eventCatData &&
                            (eventCatData.status.code === 0 ||
                                eventCatData.status.code === 200 ||
                                eventCatData.status.code === 201) &&
                            eventCatData.content
                        ) {
                            setEventCategory(eventCatData.content);
                        }
                        history.push(`/dashboard`, { from: '/dashboard' });
                    } else {
                        setUser({
                            ...user,
                            incorrectCredentials: true,
                            errorMessage: data.status.message,
                        });
                        setLoading(false);
                    }
                } else {
                    if (data && data.status) {
                        setStatusCode({
                            status: {
                                code: 401,
                                message:
                                    t('SSO_LOGIN_FAILED'),
                            },
                        });
                    }
                    setUser({
                        ...user,
                        incorrectCredentials: true,
                        errorMessage: data.status.message,
                    });
                    setLoading(false);
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleFormSubmit = (e?: any) => {
        setLoading(true);
        setUser({
            ...user,
            incorrectCredentials: false,
        });
        props.resetKeyDown(false);
        if (
            (user.email === null || user.email.length === 0) &&
            (user.password === null || user.password.length === 0)
        ) {
            setUser({
                ...user,
                incorrectCredentials: true,
                errorMessage: t("PLEASE_ENTER_AN_EMAIL_AND_PASSWORD_TO_SIGN_IN_TO_YOUR_ACCOUNT"),
            });
            setLoading(false);
            return;
        } else if (user.password === null || user.password.length === 0) {
            setUser({
                ...user,
                incorrectCredentials: true,
                errorMessage: t("PLEASE_ENTER_YOUR_PASSWORD_AND_TRY_AGAIN"),
            });
            setLoading(false);
            return;
        } else if (user.email === null || user.email.length === 0) {
            setUser({
                ...user,
                incorrectCredentials: true,
                errorMessage: t("PLEASE_ENTER_YOUR_EMAIL_ADDRESS_AND_TRY_AGAIN"),
            });
            setLoading(false);
            return;
        }
        if (
            user.email !== null &&
            user.email.length > 0 &&
            user.email.trim().match(user.emailPattern) === null
        ) {
            setUser({
                ...user,
                incorrectCredentials: true,
                errorMessage: t("LOOKS_LIKE_YOU_HAVE_ENTERED_AN_INVALID_EMAIL_ADDRESS_PLEASE_UPDATE_YOUR_EMAIL_ADDRESS_AND_TRY_AGAIN"),
            });
            setLoading(false);
            return;
        }
        loginUser();
    };

    const forgetPasswordLink = () => {
        history.push("/forgotpassword");
    };

    useEffect(() => {
        if (props.handleKeyDown) {
            handleFormSubmit();
        }
    }, [props.handleKeyDown]);

    return (
        ssoToken !== undefined && ssoToken !== null && email !== undefined && email !== null ?
            <>
                <PageLoader apiStatus={statusCode} />
            </>
            :
            <>
                <form id="loginForm">
                    <CustomBox className={classes.boxWrapper}>
                        <CustomBox className={classes.titleWrap}>
                            <CustomTypography
                                component="h1"
                                variant="h5"
                                className={classes.title}
                            >
                                {t("SIGN_IN_TO_YOUR_ACCOUNT")}
                            </CustomTypography>
                            {user.incorrectCredentials && (
                                <CustomTypography component="p" className={classes.errorMessage}>
                                    {user.errorMessage}
                                </CustomTypography>
                            )}
                        </CustomBox>
                        <CustomBox my={4}>
                            <CustomTextField
                                className={classes.input}
                                label={t("EMAIL")}
                                type="email"
                                name="email"
                                value={user.email}
                                onChange={(e) =>
                                    setUser({
                                        ...user,
                                        incorrectCredentials: false,
                                        email: e.target.value,
                                    })
                                }
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ disableUnderline: true }}
                            />{" "}
                        </CustomBox>
                        <CustomBox my={4}>
                            <CustomTextField
                                className={classes.input}
                                label={t("PASSWORD")}
                                type="password"
                                name="password"
                                value={user.password}
                                onChange={(e) =>
                                    setUser({
                                        ...user,
                                        incorrectCredentials: false,
                                        password: e.target.value,
                                    })
                                }
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    disableUnderline: true,
                                }}
                            />
                        </CustomBox>
                        <CustomBox mt={4} mb={3}>
                            <CustomButton
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={handleFormSubmit}
                            >
                                {" "}
                                {t("SIGN_IN")}{" "}
                                {loading && (
                                    <CustomCircularProgress
                                        color="inherit"
                                        style={{ marginLeft: "15px" }}
                                        size={15}
                                    />
                                )}
                            </CustomButton>
                        </CustomBox>
                        <CustomLink
                            onClick={forgetPasswordLink}
                            className={classes.forgotPassword}
                        >
                            {t("FORGOT_PASSWORD")} ?
                        </CustomLink>
                    </CustomBox>
                </form>
            </>
    );
}
